import React from 'react'
import { useLocation } from 'react-router'

type HashRouteProps = {
  hash: string,
  children: React.ReactNode,
}

/** Renders children only while the URL hash matches, e.g. '#appointment' */
export const HashRoute: React.FC<HashRouteProps> = (props) => {
  const { hash, children } = props
  const location = useLocation()
  if (location.hash !== hash) {
    return null
  }
  return <>{children}</>
}
